export default __webpack_public_path__ + "static/media/rakhi.6bb23bf5.jfif";